// @ts-nocheck
import useCurrencyStore from "@store/useCurrency.store";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {BaseButton, BaseInputNumber, BaseModal} from "@/components";
import {fichas} from "../ticketsboard/ticketsboard.consts";

const containerCls = "py-2";
const animalInfoCls =
  "text-center mb-4 px-4 py-3 bg-[linear-gradient(135deg,rgba(253,238,51,0.1)_0%,rgba(255,204,0,0.15)_100%)] rounded-lg border border-[rgba(253,238,51,0.3)]";
const labelCls = "m-0 text-xs text-[var(--color-gray-2)] mb-1 uppercase tracking-[0.5px]";
const animalNameCls = "m-0 text-lg font-bold text-[var(--color-primary)] uppercase tracking-[0.5px] max-md:text-base";
const sectionCls = "mb-4";
const sectionTitleCls = "text-[0.8rem] font-semibold text-[var(--color-gray-2)] mb-2.5 uppercase tracking-[0.3px]";
const fichasGridCls = "grid grid-cols-5 gap-2 max-md:grid-cols-3";
const fichaBtnCls =
  "flex flex-col items-center justify-center px-1 py-2 bg-[var(--color-gray-5)] border-2 border-[var(--color-surface-3)] rounded-md cursor-pointer transition-all duration-200 min-h-[var(--size-17-5)] hover:border-[var(--color-primary)] hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(253,238,51,0.25)] hover:bg-[var(--color-gray-4-alt)] max-md:min-h-[65px]";
const fichaSelectedCls =
  "!border-[var(--color-primary)] !bg-[linear-gradient(135deg,rgba(253,238,51,0.15)_0%,rgba(255,204,0,0.2)_100%)] !shadow-[0_0_0_2px_rgba(253,238,51,0.3)]";
const fichaImageCls = "w-9 h-9 object-contain mb-1 max-md:w-8 max-md:h-8";
const fichaValueCls = "text-xs font-semibold text-[var(--color-gray-1)]";
const customInputCls =
  "!bg-[var(--color-gray-5)] !border-2 !border-[var(--color-surface-3)] !text-[var(--color-gray-1)] !text-base !rounded-md hover:!border-[var(--color-primary)] focus:!border-[var(--color-primary)] focus:!shadow-[0_0_0_2px_rgba(253,238,51,0.2)]";
const selectedAmountCls =
  "mt-4 px-4 py-3 bg-[linear-gradient(135deg,var(--color-primary)_0%,var(--color-primary-hover)_100%)] rounded-lg text-center shadow-[0_4px_12px_rgba(253,238,51,0.3)] border-0 w-full cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_6px_16px_rgba(253,238,51,0.5)] hover:bg-[linear-gradient(135deg,var(--color-primary-hover)_0%,var(--color-primary)_100%)] active:translate-y-0 active:shadow-[0_2px_8px_rgba(253,238,51,0.3)] disabled:opacity-60 disabled:cursor-not-allowed disabled:translate-y-0";
const selectedLabelCls =
  "m-0 text-[0.7rem] text-[var(--color-text-inverse)] mb-0.5 uppercase font-semibold tracking-[0.5px]";
const selectedValueCls = "m-0 text-2xl font-extrabold text-[var(--color-text-inverse)] tracking-[-0.5px]";
const selectedHintCls = "m-0 mt-1 text-[0.7rem] text-black/70 font-medium tracking-[0.3px]";

const BetAmountModal = ({visible, onConfirm, onCancel, animalName, initialAmount}) => {
  const [selectedAmount, setSelectedAmount] = useState(initialAmount || null);
  const [customAmount, setCustomAmount] = useState(null);
  const selectedCurrency = useCurrencyStore(state => state.selectedCurrency);

  useEffect(() => {
    if (visible && initialAmount) {
      setSelectedAmount(initialAmount);
    }
  }, [visible, initialAmount]);

  const handleFichaClick = value => {
    setSelectedAmount(value);
    setCustomAmount(null);
  };

  const handleCustomAmountChange = value => {
    setCustomAmount(value);
    setSelectedAmount(value);
  };

  const handleConfirm = () => {
    if (selectedAmount && selectedAmount > 0) {
      onConfirm(selectedAmount);
      setSelectedAmount(null);
      setCustomAmount(null);
    }
  };

  const handleCancel = () => {
    setSelectedAmount(null);
    setCustomAmount(null);
    onCancel();
  };

  const isValid = selectedAmount && selectedAmount > 0;

  return (
    <BaseModal
      title={
        <span
          style={{
            color: "var(--color-warning-text)",
            fontWeight: 700,
            fontSize: "1.125rem",
            textTransform: "uppercase",
          }}
        >
          💰 Selecciona tu apuesta
        </span>
      }
      open={visible}
      onClose={handleCancel}
      size="md"
      footer={
        <div style={{display: "flex", gap: "var(--space-2-5)", justifyContent: "flex-end"}}>
          <BaseButton
            variant="secondary"
            onClick={handleCancel}
            className="btn-secondary-hover"
          >
            Cancelar
          </BaseButton>
          <BaseButton
            variant="primary"
            onClick={handleConfirm}
            disabled={!isValid}
            className="btn-tertiary-hover"
          >
            Apostar
          </BaseButton>
        </div>
      }
    >
      <div className={containerCls}>
        {animalName && (
          <div className={animalInfoCls}>
            <p className={labelCls}>Apostando a</p>
            <p className={animalNameCls}>{animalName}</p>
          </div>
        )}

        <div className={sectionCls}>
          <p className={sectionTitleCls}>Monto personalizado</p>
          <BaseInputNumber
            value={customAmount}
            onChange={handleCustomAmountChange}
            min={1}
            max={10000}
            placeholder="Ej: 25"
            prefix={selectedCurrency?.symbol || ""}
            className={customInputCls}
            style={{width: "100%"}}
          />
        </div>

        <div className={sectionCls}>
          <p className={sectionTitleCls}>Montos rápidos</p>
          <div className={fichasGridCls}>
            {fichas.map(ficha => (
              <button
                key={ficha.value}
                type="button"
                className={`${fichaBtnCls} ${selectedAmount === ficha.value && !customAmount ? fichaSelectedCls : ""}`}
                onClick={() => handleFichaClick(ficha.value)}
              >
                <img
                  src={ficha.image}
                  alt={`${selectedCurrency?.symbol || ""}${ficha.value}`}
                  className={fichaImageCls}
                />
                <span className={fichaValueCls}>
                  {selectedCurrency?.symbol || ""}
                  {ficha.value}
                </span>
              </button>
            ))}
          </div>
        </div>

        {selectedAmount && (
          <button
            type="button"
            className={selectedAmountCls}
            onClick={handleConfirm}
            disabled={!isValid}
          >
            <p className={selectedLabelCls}>Total a apostar</p>
            <p className={selectedValueCls}>
              {selectedCurrency?.symbol || ""}
              {selectedAmount}
            </p>
            <p className={selectedHintCls}>👆 Toca para apostar</p>
          </button>
        )}
      </div>
    </BaseModal>
  );
};

BetAmountModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  animalName: PropTypes.string,
  initialAmount: PropTypes.number,
};

export default BetAmountModal;
